import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { Loading } from '@chiroup/components/Loading';
import React, { useCallback, useEffect, useState } from 'react';

type Props = {
  url: string;
  logo?: boolean;
  className?: string;
  publicFile?: boolean;
  clinicId?: number;
};

// const UploadedImage: React.FC<Props> = ({ url }) => {
//   return (
//     <img
//       src={
//         url.includes('https://')
//           ? url
//           : `${import.meta.env.VITE_S3_ASSETS_URL}/${url}`
//       }
//       className="h-auto w-full"
//       alt={url}
//     />
//   );
// };

const UploadedImage: React.FC<Props> = ({
  url,
  className = 'h-auto w-full',
  publicFile = false,
  clinicId,
}) => {
  const [resolvedUrl, setResolvedUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPrivateFile = useCallback(
    async (fileName: string) => {
      if (!clinicId || !fileName) return;

      try {
        setIsLoading(true);
        const fetchedUrl = await ChiroUpAPI.get('api', `/${clinicId}/download`, {
          queryParams: {
            fileName,
          },
        });
        if (fetchedUrl) setResolvedUrl(fetchedUrl);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    },
    [clinicId]
  );

  useEffect(() => {
    if (!url) return;

    if (publicFile) {
      if (url.startsWith('https://') || url.startsWith('http://')) {
        setResolvedUrl(url);
      } else {
        setResolvedUrl(`${import.meta.env.VITE_S3_ASSETS_URL}/${url}`);
      }
    } else {
      fetchPrivateFile(url);
    }
  }, [publicFile, url, fetchPrivateFile]);

  if (isLoading) {
    return <Loading size={8} color="text-grey-30 mt-[2px] text-gray-500 dark:text-dark-gray-400" />;
  }

  if (resolvedUrl) {
    return <img src={resolvedUrl} className={className} alt="Uploaded file" />;
  }

  return null;
};

export default UploadedImage;
